import Vue from 'vue'
import Vuex from 'vuex'
import { ls } from './utils/common'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: ls.get('token')
  },
  mutations: {

  },
  actions: {

  }
})
